import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { Field } from '../model/field.interface';
import { FieldView } from '../model/field-view.type';

@Directive()
export abstract class AbstractFieldDirective {

  @Input() field: null | Field = null;
  @Output() fieldChange = new EventEmitter<null | Field>();

  @Input() view: FieldView = 'edit';

  protected get label(): undefined | string {
    return this.field?.label || undefined;
  }
  protected get required(): boolean {
    return this.field?.required ?? false;
  }

  protected updateRequired(required?: null | boolean): void {
    const newRequired = !!required;
    if (!this.field || this.field.required === newRequired)
      return;
    this.field.required = newRequired;
    this.fieldChange.emit(this.field);
  }

}
